// Domain split: tipping (payer) pages served on the tipper instance/domain;
// admin/worker/DB on the main instance. Both can share one MongoDB (see PRD).
export const TIPPING_URL = process.env.REACT_APP_TIPPING_URL || "";
export const TIPPING_HOST = process.env.REACT_APP_TIPPING_HOST || "";
export const MAIN_URL = process.env.REACT_APP_MAIN_URL || "";
// Hard flag for a dedicated tipper deployment: the ENTIRE instance is tipping-only.
export const TIPPING_ONLY = String(process.env.REACT_APP_TIPPING_ONLY || "").toLowerCase() === "true";

// Base used to build QR codes / shareable /pay links. Points at the tipper domain when set.
export function tippingBase() {
  return (TIPPING_URL || window.location.origin).replace(/\/$/, "");
}

// True when this instance should serve ONLY the tipping/payer surface:
// either it's the dedicated tipper deployment, or it's being served on the tipper host.
export function onTippingDomain() {
  if (TIPPING_ONLY) return true;
  return !!TIPPING_HOST && window.location.hostname === TIPPING_HOST;
}
